var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancelFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CancelFilled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.44792 2.0874C4.76125 2.0874 1.78125 5.0674 1.78125 8.75407C1.78125 12.4407 4.76125 15.4207 8.44792 15.4207C12.1346 15.4207 15.1146 12.4407 15.1146 8.75407C15.1146 5.0674 12.1346 2.0874 8.44792 2.0874ZM11.7812 11.1474L10.8413 12.0874L8.44792 9.69407L6.05458 12.0874L5.11458 11.1474L7.50792 8.75407L5.11458 6.36074L6.05458 5.42074L8.44792 7.81407L10.8413 5.42074L11.7812 6.36074L9.38792 8.75407L11.7812 11.1474Z",
    fill: "black",
    fillOpacity: 0.23
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelFilled);
export default __webpack_public_path__ + "static/media/CancelFilled.088faa16c76d8f8de9719717923e8dee.svg";
export { ForwardRef as ReactComponent };